export default "__VITE_ASSET__DxCeBaMi__"